import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../ReusableComponent/CIVIL/CivilTestToggle/Toggle.css'; // You can create a CSS file for styling
// import Modal from 'react-modal';
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';



function PhysicsTestList({ subject, tests/* , loadingTests, CUET_SubjectType  */}) {
    const location = useLocation();
    // packageid, Accesscode, Duration, MarksTotal, QuestionCount
    const [activeIndex, setActiveIndex] = useState(null);

    // const [testSeriesTests, setTestSeriesTests] = useState(tests)

    const storedAuthToken = localStorage.getItem('authtoken');


    const toggleState = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };


    return (
        <>
            <div className='card p-2 my-4 mx-2 shadow-lg'>
                {tests?.map((testData, index) => (
                    <div key={index} className="d-grid gap-1 m-1 test-togglebackground">
                        <button onClick={() => toggleState(index)} className="toggle-button py-2 d-flex justify-content-between">
                            <div className="text-nowrap me-2">
                                {subject}
                            </div>
                            <div className=' me-3 mt-0'>
                                <h1 className='fs-6'>Test {index + 1}</h1>
                            </div>
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
}

export default PhysicsTestList;

